import uniqBy from 'lodash.uniqby';
import excludeServicesWithoutOffice from './excludeServicesWithoutOffice';

export const CATEGORY_TYPES = {
  BUSINESS: 'BUSINESS',
  UTILITIES: 'UTILITIES',
  TAXES: 'TAXES',
  HOME: 'HOME',
  DOCUMENT: 'DOCUMENT',
  PENSION: 'PENSION',
  TRANSPORT: 'TRANSPORT',
  WORK: 'WORK',
  FAMILY: 'FAMILY',
  SOCIAL: 'SOCIAL',
  RITUAL: 'RITUAL',
  OTHER: 'OTHER',
};

const mapRootCategoryKeyToClient = key => {
  const map = {
    biznes: CATEGORY_TYPES.BUSINESS,
    kommunalnye_uslugi: CATEGORY_TYPES.UTILITIES,
    nalogi: CATEGORY_TYPES.TAXES,
    nedvizhimost_stroitelstvo_zemlya: CATEGORY_TYPES.HOME,
    osnovnye_dokumenty_grazhdanina: CATEGORY_TYPES.DOCUMENT,
    pensii: CATEGORY_TYPES.PENSION,
    transport: CATEGORY_TYPES.TRANSPORT,
    rabota: CATEGORY_TYPES.WORK,
    semya_deti: CATEGORY_TYPES.FAMILY,
    socialnaya_podderzhka: CATEGORY_TYPES.SOCIAL,
    poterya_blizkogo_cheloveka: CATEGORY_TYPES.RITUAL,
    inoe: CATEGORY_TYPES.OTHER,
  };

  return map[key];
};

const formatServiceToClient = (service, actualOfficesIdsSet) => ({
  id: service.id,
  name: service.name,
  officesIds: uniqBy(
    service.mfcs
      .filter(mfc => actualOfficesIdsSet.has(mfc.id))
      .map(mfc => mfc.id)
  ),
});

const formatCategoryToClient = (category, actualOfficesIdsSet) => ({
  id: category.id,
  name: category.title,
  services: category.services.map(service =>
    formatServiceToClient(service, actualOfficesIdsSet)
  ),
});

const formatRootCategoryToClient = (rootCategory, actualOfficesIdsSet) => ({
  id: rootCategory.uniquetextkey,
  slug: mapRootCategoryKeyToClient(rootCategory.uniquetextkey),
  name: rootCategory.rootcategory,
  servicesCount: rootCategory.servicecount,
  categories: rootCategory.catalog.map(category =>
    formatCategoryToClient(category, actualOfficesIdsSet)
  ),
});

const formatCatalogToClient = (catalog, offices) => {
  const actualOfficesIdsSet = new Set(offices.map(office => office.id));

  const formattedCatalog = catalog.map(rootCategory =>
    formatRootCategoryToClient(rootCategory, actualOfficesIdsSet)
  );

  return excludeServicesWithoutOffice(formattedCatalog);
};

export default formatCatalogToClient;
